import { Loader2 } from 'lucide-react';
import { usePancakeStore } from '../../store/pancake.store';
import PancakeDashboardFilters from './PancakeDashboardFilters';
import PancakeOverview from './PancakeOverview';
import ConversationsList from './ConversationsList';
import PancakeStatsCharts from './PancakeStatsCharts';
import PancakeCustomersTable from './PancakeCustomersTable';
import PancakePostsList from './PancakePostsList';

interface Props {
  isDark: boolean;
  theme: Record<string, string>;
}

export default function PancakeDashboardContent({ isDark }: Props) {
  const { activeView, isLoading, error, fetchedKeys } = usePancakeStore();

  const hasFetched = Object.keys(fetchedKeys).length > 0;

  return (
    <>
      <PancakeDashboardFilters isDark={isDark} />

      {error && (
        <div className="mt-4 p-4 bg-red-900/50 border border-red-500/50 rounded-lg text-red-200">
          {error}
        </div>
      )}

      {isLoading && (
        <div className="flex items-center justify-center py-20">
          <Loader2 className="w-8 h-8 text-cyan-500 animate-spin" />
        </div>
      )}

      {!isLoading && !hasFetched && (
        <div className="flex flex-col items-center justify-center py-20 text-slate-500">
          <p className="text-sm">Chọn khoảng thời gian và nhấn "Chạy report" để xem dữ liệu Pancake</p>
        </div>
      )}

      {!isLoading && hasFetched && (
        <div className="mt-4 space-y-6">
          {activeView === 'overview' && <PancakeOverview isDark={isDark} />}
          {activeView === 'conversations' && <ConversationsList isDark={isDark} />}
          {activeView === 'statistics' && <PancakeStatsCharts isDark={isDark} />}
          {activeView === 'customers' && <PancakeCustomersTable isDark={isDark} />}
          {activeView === 'posts' && <PancakePostsList isDark={isDark} />}
        </div>
      )}
    </>
  );
}
